import api from './api';

const BASE = '/api/aggregate';

/**
 * Fetch approved harvest records with coordinates for biological categories,
 * for rendering a cross-community species distribution map.
 */
export const getSpeciesMap = () =>
  api.get(`${BASE}/species-map`);

/**
 * Fetch approved environmental harvest records with coordinates,
 * for rendering a cross-community environmental observations map.
 */
export const getPollutionMap = () =>
  api.get(`${BASE}/pollution-map`);

/**
 * Fetch approved harvest records with coordinates, with optional filters.
 * @param {object} params  { category?, species?, fromDate?, toDate? }
 */
export const getAggregateHarvesting = (params = {}) =>
  api.get(`${BASE}/harvesting`, { params });

/**
 * Fetch aggregate statistics across all tenants:
 *   { byTenant, byCategory, bySeason }
 */
export const getCrossCommunityReport = () =>
  api.get(`${BASE}/report`);
